import { useEffect, useState } from 'react';
import { FundRequestExpenseTypes } from '~/enums/fundRequest';
import { ExpenseItem } from '~/types/fundrequests';

const FlagIssueModal = ({
    modalOpen,
    setModalOpen,
    selectedExpenseCategory,
    selectedExpenseItem,
    handleFlagItem,
    saving,
}: {
    modalOpen: boolean;
    setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
    selectedExpenseCategory: FundRequestExpenseTypes | undefined;
    selectedExpenseItem: ExpenseItem | undefined;
    handleFlagItem: (
        expenseItem: ExpenseItem | undefined,
        type: FundRequestExpenseTypes | undefined,
        comment: string
    ) => void;
    saving: boolean;
}) => {
    const [comment, setComment] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setComment(event.target.value);
    };

    useEffect(() => {
        if (!modalOpen) {
            setComment('');
            setIsSubmitting(false);
        }
    }, [modalOpen]);

    return (
        <>
            {modalOpen && (
                <div
                    className='fixed inset-0 z-[99999] flex items-center justify-center bg-black bg-opacity-75'
                    onClick={() => setModalOpen(false)}
                >
                    <div
                        onClick={(e) => e.stopPropagation()}
                        className='relative w-full max-w-xl rounded-lg bg-white shadow-lg'
                    >
                        <div className='p-7'>
                            <h1 className='text-3xl font-semibold'>
                                Flag Issue
                            </h1>

                            <p className='mt-6'>
                                You are flagging this expense item as having an
                                error. Please provide some information for the
                                Client in order to help them make the necessary
                                changes.
                            </p>
                            <div className='mt-6'>
                                <label className='block font-bold'>
                                    Issue <span className='text-red'>*</span>
                                </label>
                                <textarea
                                    className='w-full resize-none rounded border p-2'
                                    rows={6}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className='mb-[30px] flex gap-[16px]'>
                                <button
                                    onClick={() => setModalOpen(false)}
                                    type='button'
                                    className='mt-[30px]  rounded-full border-[2px] px-[24px] py-[7px] text-[14px]/[18px] font-bold uppercase transition-colors duration-500 hover:border-[#E6F7F8] hover:bg-[#E6F7F8]'
                                >
                                    Cancel
                                </button>
                                <button
                                    type='button'
                                    className={`mt-[30px] w-40 rounded-full border-[2px] border-[#F02D3A] bg-[#F02D3A] px-[24px] py-[7px] text-[14px]/[18px] font-bold uppercase text-white transition-colors duration-500 ${
                                        isSubmitting || saving
                                            ? 'cursor-not-allowed opacity-50'
                                            : 'hover:border-[#E6F7F8] hover:bg-[#E6F7F8]'
                                    }`}
                                    onClick={() => {
                                        setIsSubmitting(true);
                                        handleFlagItem(
                                            selectedExpenseItem,
                                            selectedExpenseCategory,
                                            comment
                                        );
                                    }}
                                    disabled={isSubmitting || saving} // Disable button while submitting
                                >
                                    {saving ? `Saving` : `RECORD ERROR`}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default FlagIssueModal;
